@if (!oidcServerEnabled) {
  <form [formGroup]="loginForm" (ngSubmit)="login()" id="login-form" novalidate>
    <div class="field">
      <label class="field__label" for="login-username">
        {{ "labels.inputs.Username" | translate }}
      </label>
      <input
        id="login-username"
        class="field__input"
        type="text"
        autocomplete="username"
        formControlName="username"
        [class.field__input--invalid]="showError('username')"
      />
      @if (showError("username")) {
        <p class="field__error">
          {{ "labels.inputs.Username" | translate }}
          {{ "labels.commons.is required" | translate }}
        </p>
      }
    </div>

    <div class="field">
      <label class="field__label" for="login-password">
        {{ "labels.inputs.Password" | translate }}
      </label>
      <div class="field__wrap">
        <input
          id="login-password"
          class="field__input field__input--with-action"
          [type]="passwordInputType"
          autocomplete="current-password"
          formControlName="password"
          [class.field__input--invalid]="showError('password')"
        />
        <button
          type="button"
          class="field__action"
          (click)="togglePasswordVisibility()"
          [disabled]="loading"
          [attr.aria-label]="
            (passwordInputType === 'password'
              ? 'login.signIn.showPassword'
              : 'login.signIn.hidePassword'
            ) | translate
          "
        >
          <fa-icon
            [icon]="passwordInputType === 'password' ? 'eye' : 'eye-slash'"
          ></fa-icon>
        </button>
      </div>
      @if (showError("password")) {
        <p class="field__error">
          {{ "labels.inputs.Password" | translate }}
          {{ "labels.commons.pass is required" | translate }}
        </p>
      }
    </div>

    @if (enableRememberMe) {
      <label class="remember">
        <input type="checkbox" formControlName="remember" />
        {{ "login.signIn.rememberMe" | translate }}
      </label>
    }

    <!-- Placeholder captcha: UI only, no verification against a provider -->
    <div
      class="captcha"
      [class.captcha--verified]="captchaState === 'verified'"
    >
      <button
        type="button"
        class="captcha__box"
        role="checkbox"
        [attr.aria-checked]="captchaState === 'verified'"
        [attr.aria-label]="'login.signIn.notRobot' | translate"
        [disabled]="loading || captchaState !== 'idle'"
        (click)="verifyCaptcha()"
      >
        @if (captchaState === "verifying") {
          <span class="captcha__spinner"></span>
        }
        @if (captchaState === "verified") {
          <svg class="captcha__tick" viewBox="0 0 24 24" aria-hidden="true">
            <path d="M4 12.5l5 5L20 6.5" />
          </svg>
        }
      </button>
      <span class="captcha__text">{{
        "login.signIn.notRobot" | translate
      }}</span>
      <span class="captcha__brand" aria-hidden="true">
        <svg viewBox="0 0 24 24">
          <path d="M20 12a8 8 0 0 1-14.3 4.9" />
          <path d="M4 12a8 8 0 0 1 14.3-4.9" />
          <path d="M18.5 3v4.2h-4.2" />
          <path d="M5.5 21v-4.2h4.2" />
        </svg>
        reCAPTCHA
      </span>
    </div>

    @if (loading) {
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    }

    <button
      type="submit"
      class="submit"
      [disabled]="!loginForm.valid || captchaState !== 'verified' || loading"
    >
      @if (loading) {
        <mat-spinner [diameter]="18"></mat-spinner>
      } @else {
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M15 4h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3" />
          <path d="M10 8l4 4-4 4" />
          <path d="M14 12H4" />
        </svg>
      }
      {{ "login.signIn.button" | translate }}
    </button>
  </form>
}

@if (oidcServerEnabled) {
  <div class="container container-margin">
    @if (!isLoggedIn) {
      <div class="layout-column align-center-center">
        <button
          mat-raised-button
          color="primary"
          class="login-button-first flex-align-center"
          (click)="loginOIDC()"
        >
          {{ "labels.buttons.Login" | translate }}
          @if (loading) {
            <mat-spinner [diameter]="20"></mat-spinner>
          }
        </button>
      </div>
    }
    @if (isLoggedIn) {
      <div>
        <p>{{ "login.oidc.welcomeLoggedIn" | translate }}</p>
        <button (click)="logout()">
          {{ "login.oidc.logout" | translate }}
        </button>
        <button (click)="loadProtectedData()">
          {{ "login.oidc.loadProtectedData" | translate }}
        </button>
        <pre>{{ protectedData | json }}</pre>
      </div>
    }
  </div>
}
